<template>
  <!-- this is a wrapper component, it "sends" (by using $attrs & $listeners) all of the props that were passed to it
  to the wrapped component, in this case, that's v-autocomplete -->
  <v-autocomplete
    ref="autocomplete"
    v-bind="$attrs"
    :menu-props="{maxWidth:'340px'}"
    :outlined="layoutShape.dropdown === 'outlined'"
    :solo="layoutShape.dropdown === 'solo'"
    :filled="layoutShape.filledDropdown"
    :rounded="layoutShape.roundDropdown"
    hide-details="auto"
    :height="layoutShape.dropdown === 'outlined' || layoutShape.dropdown === 'solo' ? 50 : ''"
    color="elements" item-color="elements" class="baseAutocomplete"
    @keydown.enter="emitEnterPress"
    v-on="$listeners">
    <slot slot="label" name="label" />
    <template v-if="multipleRes" #prepend-item>
      <v-list-item
        ripple
        @mousedown.prevent
        @click="toggle">
        <v-list-item-action>
          <v-icon>
            {{ icon() }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ labels.selectAll }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2" />
    </template>
    <template v-if="itemText() !== 'noText'" #item="data">
      <v-tooltip
        v-if="data.item[itemText()] && data.item[itemText()].length > 45" top nudge-top="-33"
        nudge-right="10">
        <template #activator="{on, attrs}">
          <v-list-item-title v-bind="attrs" v-on="on">
            <strong v-if="data.item.strong">
              {{ data.item[itemText()] }}
            </strong>
            <span v-else>
              {{ data.item[itemText()] }}
            </span>
          </v-list-item-title>
        </template>
        <span>{{ data.item[itemText()] }}</span>
      </v-tooltip>

      <v-list-item-content v-else>
        <v-list-item-title>
          <strong v-if="data.item.strong">
            {{ data.item[itemText()] }}
          </strong>
          <span v-else>
            {{ data.item[itemText()] }}
          </span>
        </v-list-item-title>
      </v-list-item-content>
    </template>
    <template #append>
      <v-icon id="menuDown">
        mdi-menu-down
      </v-icon>
    </template>
    <template #append-outer>
      <slot name="append-outer" />
    </template>
    <template v-if="selection && selection.length > 1 && itemText() !== 'noText'" #selection="{item, index}">
      <span v-if="index === 0 && item[itemText()].toString().length < 27" style="color:rgba(0, 0, 0, 0.87);">
        {{ item[itemText()].toString() }}
      </span>
      <span v-if="index === 0 && item[itemText()].length > 26" style="color:rgba(0, 0, 0, 0.87);">
        {{ item[itemText()].toString().substr(0, 18) }}...
      </span>
      <span v-if="index === 1" class="grey--text caption ml-2">
        (+{{ selection.length - 1 }} )
      </span>
    </template>
    <template v-else-if=" itemText() !== 'noText'" #selection="{item}">
      <span v-if="item[itemText()].length > 26" style="color:rgba(0, 0, 0, 0.87);">
        {{ item[itemText()].toString().substr(0, 25) }}...
      </span>
      <span v-else style="color:rgba(0, 0, 0, 0.87);">
        {{ item[itemText().toString()] }}
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
import { eventBus } from '../../main.js'
export default {
  name: 'BaseAutocomplete',
  props: {
    selection: { type: Array, default () { return [] } },
    multipleRes: { type: Boolean, default () { return false } },
    selectionItems: { type: Array, default () { return [] } },
    placeHolderLabel: { type: String, default () { return this.selection[0]?.toString() } },
  },
  data () {
    return {
      layoutShape: null,
      selectionProps: [],
    }
  },
  computed: {
    activeTool () {
      return this.$store.getters.getActiveTool
    },
    labels () {
      return this.getLabels(this.$store.getters.getLanguage).home
    },
  },
  watch: {
    selection (newValue) {
      this.selectionProps = newValue
    },
  },
  created () {
    this.layoutShape = this.$store.getters.getConfigJson.layoutShape
  },
  mounted () {
    // TODO potentially refactor? because this will run multiple times since we are mounting multiple BaseAutocomplete components
    // this should only run once?
    const selectedDomNodes = document.querySelectorAll('div.baseAutocomplete input[type=text]')
    if (selectedDomNodes) {
      for (const domNode of selectedDomNodes) {
        domNode.classList.add('widgetsList--text')
      }
    }
  },
  methods: {
    emitEnterPress () {
      eventBus.$emit('enter-pressed', this.activeTool)
    },
    itemText () {
      return this.$refs.autocomplete?.itemText ? this.$refs.autocomplete.itemText : 'noText'
    },
    itemValue () {
      return this.$refs.autocomplete?.itemValue ? this.$refs.autocomplete.itemValue : 'value'
    },
    selectAll () {
      return this.selection?.length === this.selectionItems?.length
    },
    selectSome () {
      return this.selection?.length > 0 && !this.selectAll()
    },
    icon () {
      if (this.selectAll()) return 'mdi-close-box'
      if (this.selectSome()) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    toggle () {
      this.$nextTick(() => {
        if (this.selectAll()) {
          this.$emit('change-selection', [])
          this.selectionProps = []
        } else {
          let pomSelection = []
          if (this.itemValue() !== 'value') {
            for (const item of this.selectionItems) {
              pomSelection.push(item[this.itemValue()])
            }
          } else if (this.selectionItems[0].value) {
            for (const item of this.selectionItems) {
              pomSelection.push(item[this.itemValue()])
            }
          } else {
            pomSelection = this.selectionItems
          }
          this.$emit('change-selection', pomSelection)
          this.selectionProps = this.selectionItems
        }
      })
    },
  },
}
</script>
<style scoped>
#menuDown:hover{
  cursor: pointer !important;
}
.baseAutocomplete>>>.v-select__slot input {
  font-weight: 500 !important;
}
.v-input>>>.v-label {
    font-size: 14px;
}
.v-input>>>.v-icon.v-icon {
  font-size: 18px;
}
.v-menu__content {
  max-width: 340px;
}
</style>
